module.exports = __webpack_public_path__ + "img/external-content.duckduckgo.com.738cd373.png";